import I18n from 'i18n-js';

import { ENGLISH, FRENCH, GERMAN, SPANISH } from '@lootboy/translations/config';

import Badge from '~/components/AppBadges/Badge';

import googlePlayDe from '~/assets/images/app-badges/googlePlay-de.svg';
import googlePlayEn from '~/assets/images/app-badges/googlePlay-en.svg';
import googlePlayEs from '~/assets/images/app-badges/googlePlay-es.svg';
import googlePlayFr from '~/assets/images/app-badges/googlePlay-fr.svg';

const images = {
  [GERMAN]: googlePlayDe,
  [ENGLISH]: googlePlayEn,
  [SPANISH]: googlePlayEs,
  [FRENCH]: googlePlayFr,
};
const GooglePlayBadge = ({
  recruiter,
}: {
  recruiter?: string;
}): JSX.Element => {
  const basePlayUrl = I18n.t('common_google_play_store_url');
  const playUrl = recruiter
    ? `${basePlayUrl}&referrer=${encodeURIComponent(`recruiter=${recruiter}`)}`
    : basePlayUrl;

  return (
    <Badge
      images={images}
      href={playUrl}
      title="google playstore"
    />
  );
};

GooglePlayBadge.displayName = 'GooglePlayBadge';

export default GooglePlayBadge;
